<template>
    <div class="evaluation-comment">
        <div class="comment-wrap">
            <div class="item" v-for="(item, index) in commentsLimit" :key="index">
                <div class="shot-wrap">
                    <div class="shot">
                        <img v-if="item.avatarUrl" class="shot-img" :src="imageUrl(item.avatarUrl)" alt="">
                        <img v-else class="shot-img" src="@/assets/img/shareHouse/shot.svg" alt="">
                        <!-- <img class="award" src="@/assets/img/shareHouse/award.svg" alt=""> -->
                    </div>
                </div>
                <div class="comment-group">
                    <div class="name">
                        {{item.tenantName}}
                    </div>
                    <div class="eval-and-date">
                        <div class="star">
                            <img src="@/assets/img/shareHouse/star_orange.svg" alt="">
                            {{item.rate}}
                        </div>
                        <div class="contract-date">
                            {{getFormatDate(item.contractBeginTime)}}-{{getFormatDate(item.contractEndTime)}}
                        </div>
                    </div>
                    <div class="comment">
                        {{item.comment}}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="comments.length > 5" class="load-more" @click="openModal()">
            <button>
                查看全部評價
            </button>
        </div>
        <div :key="componentKey" v-if="loadMoreMb && comments.length > 5" class="load-more-mb" @click="loadMore()">
            查看全部評價
            <img src="@/assets/img/shareHouse/arrow_down.svg" alt="">
        </div>
        <evaluation-comment-modal v-if="modalStatus.evaluationCommentModal"></evaluation-comment-modal>
    </div>
</template>
<script>
import evaluationCommentModal from '@/components/shareHouse/evaluationCommentModal.vue';
import { mapGetters } from 'vuex'
import { 
        baseDomain,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            componentKey: 0,
            loadPage: 5,
            loadMoreMb: true
        }
    },
    methods: {
        loadMore: function () {
            this.loadPage += 5
            if(this.loadPage >= this.comments.length){
                this.loadPage = this.comments.length
                this.loadMoreMb = false
                this.componentKey += 1
            }
        },
        openModal: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'evaluationCommentModal'})
        },
        imageUrl: function (url) {
            return baseDomain+url
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'年'+formatDate[5]+'月';
        },
    },
    computed: {
        commentsLimit: function () {
            return this.comments.slice(0, this.loadPage)
        },
        ...mapGetters({
            comments: 'GET_SHARE_HOUSE_RATE_COMMENT',
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        evaluationCommentModal
    }
}
</script>
<style lang="scss" scoped>
    .evaluation-comment{
        position: relative;
        border-top: solid 1px #d7d9db;
        margin-top: 24px;
        .comment-wrap{
            .item{
                display: flex;
                justify-content: space-between;
                padding-top: 25px;
                .shot-wrap{
                    width: 56px;
                    height: 56px;
                    margin-right: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .shot{
                        position: relative;
                        /* margin-right: 28px; */
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        /* padding: 2px; */
                        width: 54.5px;
                        height: 54.5px;
                        border-radius: 50%;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0.2px;
                        left: 0.3px;
                        .shot-img{
                            width: 100%;
                            /* height: 100%; */
                            
                        }
                        .award{
                            position: absolute;
                            position: absolute;
                            bottom: -11px;
                            right: -5px;
                        }
                        
                    }
                    // .shot.good{
                    //     background-image: linear-gradient(to bottom, #9defff, #3fccfc);  
                    // }
                }
                .comment-group{
                    width: 87.65%;
                    font-size: 16px;
                    border-bottom: solid 1px #d7d9db;
                    padding-bottom: 25px;
                    .name{
                        margin-bottom: 12px;
                    }
                    .eval-and-date{
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        .star{
                            position: relative;
                            display: flex;
                            align-items: center;
                            margin-right: 23px;
                            img{
                                width: 14px;
                                margin-right: 6px;
                            }
                        }
                        .star::after{
                            content: '';
                            position: absolute;
                            width: 1px;
                            height: 10px;
                            background: #979797;
                            right: -12px;
                        }
                        .contract-date{
                            color: #909090;
                        }
                    }
                    .comment{
                        font-size: 16px;
                        line-height: 1.5;
                    }
                }
            }
        }
        .load-more{
            width: 100%;
            display: flex;
            justify-content: flex-end;
            button{
                width: 87.65%;
                font-size: 18px;
                border-radius: 8px;
                border: solid 1px #3a455f;
                color: #3a455f;
                padding: 11px 0;
                margin-top: 50px;
                text-align: center;
                background: #fff;
                cursor: pointer;
            }
        }
        .load-more-mb{
            display: none;
        }
    }
    @media (max-width: 992px) {
        .evaluation-comment{
            .comment-wrap{
                width: 100%;
                .item{
                    display: block;
                    justify-content: flex-start;
                    padding-top: 25px;
                    .shot{
                        width: 40px;
                        height: 40px;
                        img{
                            width: 100%;
                        }
                    }
                    .comment-group{
                        position: relative;
                        margin-top: -39px;
                        width: 100%;
                        font-size: 14px;
                        .name{
                            position: relative;
                            margin-bottom: 6px;
                            left: 55px;
                            font-size: 16px;
                        }
                        .eval-and-date{
                            position: relative;
                            left: 55px;
                        }
                        .comment{
                            font-size: 14px;
                            line-height: 1.5;
                        }
                    }
                }
                .item:last-child{
                    .comment-group{
                        border: 0;
                    }
                }
            }
            .load-more{
                display: none;
            }
            .load-more-mb{
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                color: #3a455f;
                cursor: pointer;
                img{
                    margin-left: 6px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/evaluationComment.vue